/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from 'react';
import ThemeContext from 'contexts/ThemeContext';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import api from 'api';
import {
  SideMenu,
  DataTable,
  Input,
  FilterButton,
  Button,
  Select,
  Toolbar,
  ConfirmDialog,
} from 'components';
import {
  Container,
  ContentArea,
  TitleArea,
  DataArea,
  LoadingArea,
  FilterArea,
} from './styles';
import { dataColumns } from './helper';
import { toast } from 'react-toastify';
import { IconButton, Tooltip } from '@material-ui/core';
import { TbTrashX } from 'react-icons/tb';

function List({ history }) {
  const scrollParent = useRef();
  const { loadingColor } = useContext(ThemeContext);

  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showConfirm, setShowConfirm] = useState();

  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [dataList, setDataList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [search, setSearch] = useState();
  const [status, setStatus] = useState();
  const [role, setRole] = useState();

  const loadData = async () => {
    setLoading(true);
    setDataList([]);
    const resp = await api.post(
      '/invites',
      { page: currentPage, take: 20 },
      {
        headers: {
          role,
          status,
          search,
        },
      }
    );
    setDataList(resp?.data?.invites);
    setTotalCount(resp?.data?.totalCount);
    setHasNextPage(resp?.data?.hasNextPage);

    const respRoles = await api.get('/list-roles');
    setRolesList(respRoles?.data?.data);

    setLoading(false);
  };

  const handleLoadMore = async () => {
    const page = currentPage + 1;

    if (hasNextPage) {
      setLoadingMore(true);

      const resp = await api.post(
        '/invites',
        { page, take: 10 },
        {
          headers: {
            role,
            status,
            search,
          },
        }
      );

      const data = dataList;
      const ndata = data.concat(resp?.data?.invites);

      setCurrentPage(page);
      setDataList(ndata);
      setHasNextPage(resp?.data?.hasNextPage);
      setLoadingMore(false);
    }
  };

  const handleDelete = async () => {
    setLoadingDelete(true);

    try {
      await api.put(`/invite/cancel/${showConfirm?.id}`);
      setLoadingDelete(false);
      toast.success('Convite cancelado com sucesso!');
      loadData();
    } catch (e) {
      setLoadingDelete(false);
      toast.error(e?.response?.data?.error);
    }
  };

  const renderConfirmDialog = () => (
    <ConfirmDialog
      open={Boolean(showConfirm)}
      onCancel={() => setShowConfirm()}
      content="Tem certeza de que deseja cancelar este convite?"
      title="Cancelar convite"
      loading={loadingDelete}
      onConfirm={() => {
        handleDelete();
        setShowConfirm();
      }}
    />
  );

  useEffect(() => {
    loadData();
  }, []);

  const renderFilters = () => (
    <SwipeableDrawer
      anchor="right"
      open={showFilters}
      onClose={() => setShowFilters(false)}>
      <FilterArea>
        <h1>Filtros</h1>

        <Select
          label="Perfil"
          width="250px"
          value={role}
          onChange={(e) =>
            setRole(e.target.value === 'all' ? undefined : e.target.value)
          }>
          <option value="all">Todos</option>
          {rolesList?.map((role) => (
            <option value={role?.id}>{role?.name}</option>
          ))}
        </Select>

        <Select
          label="Status"
          width="250px"
          value={status}
          onChange={(e) =>
            setStatus(e.target.value === 'all' ? undefined : e.target.value)
          }>
          <option value="all">Todos</option>
          <option value={1}>Ativo</option>
          <option value={0}>Inativo</option>
        </Select>

        <Button
          onClick={() => {
            setShowFilters(false);
            loadData();
          }}
          style={{ marginTop: 20 }}
          width="250px">
          Aplicar
        </Button>
      </FilterArea>
    </SwipeableDrawer>
  );

  const deleteDataColumns = [
    ...dataColumns,
    {
      name: '',
      selector: (row) =>
        row.status === 'pending' && (
          <Tooltip
            title="Cancelar convite"
            placement="right"
            onClick={() => setShowConfirm(row)}>
            <IconButton>
              <TbTrashX size={15} />
            </IconButton>
          </Tooltip>
        ),
      width: '10%',
      sortable: true,
    },
  ];

  return (
    <Container>
      {renderFilters()}
      {renderConfirmDialog()}
      <SideMenu />
      <ContentArea>
        <TitleArea>
          <h1>Convites</h1>
        </TitleArea>
        <Toolbar>
          <div>
            <Button
              onClick={() => history.push('/convites/novo')}
              height="30px"
              width="150px">
              Convidar usuário
            </Button>
          </div>
          <div>
            <FilterButton onClick={() => setShowFilters(true)} />
            <Input
              search
              handleClean={() => {
                setSearch();
                loadData();
              }}
              height="32px"
              placeholder="Buscar..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  loadData();
                }
                if (e.key === 'Escape') {
                  setSearch();
                  loadData();
                }
              }}
            />
          </div>
        </Toolbar>
        <DataArea ref={scrollParent}>
          <InfiniteScroll
            loadMore={handleLoadMore}
            hasMore={hasNextPage}
            useWindow={false}
            getScrollParent={() => scrollParent?.current}
            initialLoad={false}
            style={{ width: '100%', display: 'flex' }}
            threshold={10}>
            <DataTable
              persistTableHead
              responsive
              columns={deleteDataColumns}
              data={dataList}
              highlightOnHover
              progressPending={loading}
              progressComponent={
                <LoadingArea>
                  <ReactLoading
                    color={loadingColor}
                    height={32}
                    width={32}
                    type="spin"
                  />
                </LoadingArea>
              }
              noDataComponent={
                <small style={{ marginTop: 20 }}>
                  Nenhum convite encontrado
                </small>
              }
            />
          </InfiniteScroll>
        </DataArea>
        {!loading && !loadingMore && (
          <small className="counter-area">
            Mostrando {dataList?.length} de {totalCount}
          </small>
        )}
        {loadingMore && (
          <LoadingArea>
            <ReactLoading
              type="spin"
              color={loadingColor}
              height={25}
              width={25}
            />
          </LoadingArea>
        )}
      </ContentArea>
    </Container>
  );
}

export default List;
